import "./TypeOfNote.css";

const VARIANTS = {
  vision: {
    headerTitle: "You're building something real.",
    headerSub: "Everything below is included. No strings.",
    proDesc: "Full access. No credit card. No limits.",
    features: [
      { icon: "bx-plus-circle",     label: "Create & post your record" },
      { icon: "bx-infinite",        label: "Unlimited updates" },
      { icon: "bx-show",            label: "Visibility controls: public or private" },
      { icon: "bx-rocket",          label: "Release when ready" },
      { icon: "bx-bot",             label: "AI Assist: Strategist, Mirror, Challenger, Therapist" },
      { icon: "bx-bar-chart-alt-2", label: "AI Reports" },
      { icon: "bx-planet",          label: "Space View: your vision in full" },
    ],
    publishLabel: "Publish Vision",
    publishingLabel: "Posting…",
  },
  sideQuest: {
    headerTitle: "You're posting a side quest.",
    headerSub: "A small thing you've decided to go after. Track it like the rest.",
    proDesc: "Lightweight, focused, fully yours.",
    features: [
      { icon: "bx-target-lock",   label: "A standalone quest, on the record" },
      { icon: "bx-infinite",      label: "Unlimited updates as you progress" },
      { icon: "bx-show",          label: "Public or private, your call" },
      { icon: "bx-bot",           label: "Dmyor Assist for direction when you're stuck" },
      { icon: "bx-check-circle",  label: "Mark complete when it's done" },
    ],
    publishLabel: "Publish Side Quest",
    publishingLabel: "Posting…",
  },
  visionExpand: {
    headerTitle: "Publishing your Vision opens the rest of the system.",
    headerSub: "You've put one Record down. Now make the bigger picture official.",
    proDesc: "Everything below unlocks the moment your Vision goes live.",
    features: [
      { icon: "bx-plus-circle",     label: "Add more Records across categories" },
      { icon: "bx-target-lock",     label: "Side Quests for smaller pursuits" },
      { icon: "bx-pulse",           label: "Plan Health: see your Vision's vitals" },
      { icon: "bx-planet",          label: "Space View: your Vision in full view" },
      { icon: "bx-rocket",          label: "Release Records when ready" },
      { icon: "bx-bot",             label: "AI Assist on every Record" },
    ],
    publishLabel: "Publish Vision",
    publishingLabel: "Publishing…",
  },
};

const TypeOfNote = ({ handleBack, handlePost, btnloading, kind = "vision" }) => {
  const v = VARIANTS[kind] || VARIANTS.vision;

  return (
    <div className="ton-wrapper">

      <div className="ton-header">
        <h2 className="ton-title">{v.headerTitle}</h2>
        <p className="ton-sub">{v.headerSub}</p>
      </div>

      <div className="ton-pro-card">
        <div className="ton-pro-top">
          <div className="ton-pro-title-row">
            <span className="ton-pro-name">Pro</span>
            <span className="ton-pro-free-badge">Free for now</span>
          </div>
          <p className="ton-pro-desc">{v.proDesc}</p>
        </div>

        <div className="ton-pro-divider" />

        <ul className="ton-pro-features">
          {v.features.map((f) => (
            <li key={f.icon} className="ton-pro-feature">
              <span className="ton-pro-icon-wrap">
                <i className={`bx ${f.icon}`} />
              </span>
              <span className="ton-pro-feature-label">{f.label}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="ton-nav">
        <button className="ton-back-btn" onClick={handleBack} type="button">
          Back
        </button>
        <button
          className="ton-post-btn"
          onClick={handlePost}
          disabled={btnloading}
          type="button"
        >
          {btnloading ? v.publishingLabel : v.publishLabel}
        </button>
      </div>

    </div>
  );
};

export default TypeOfNote;
